// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\r\n/* 숫자만 입력 가능 */\n.no-spin-button[data-v-7bf52400]::-webkit-inner-spin-button,\r\n.no-spin-button[data-v-7bf52400]::-webkit-outer-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\n}\n.no-spin-button[data-v-7bf52400] {\r\n  -webkit-appearance: textfield;\r\n     -moz-appearance: textfield;\r\n          appearance: textfield;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
